import React from 'react';
import { useIntl } from 'react-intl';
import { formatDistance } from 'date-fns';
import { Locale } from '../../../../types/gatsby';
import { dateLocalesMapping } from '../../../../helpers/reviewHelper';

export const TimeAgo = ({ date }: { date: string }) => {
  const intl = useIntl();
  const locale = intl.locale as Locale;

  try {
    if (!date || Number.isNaN(Date.parse(date))) {
      throw new Error('Invalid date, cannot parse it');
    }

    return (
      <>
        / {' '}
        {`${formatDistance(new Date(date), new Date(), {
          addSuffix: true, locale: dateLocalesMapping[locale],
        })}`}
      </>
    );
  } catch {
    return null;
  }
};
